import { OrganizerChannel } from '@pages/event/api/useSendAuthQrcodeToOrganizer';
import { SendChannel } from '@pages/event/api/useSendMessages';
import type { SelectValue } from '@shared/ui/select';

export const HEADER_TITLES = {
  SENDING: 'Отправка',
  UNDELIVERED_TICKETS: 'Недоставленные билеты',
  SEND_QR_TICKETS: 'Отправить QR-билеты',
  SEND_QR_CODE: 'Отправить QR-код',
  SEND_TICKETS: 'Отправить билеты',
};

export const INVITATION_TYPE_VALUES = {
  SMS: 'type1',
  EMAIL: 'type2',
  BOTH: 'type3',
  VK: 'type4',
};

export const TICKET_CHANNEL_OPTIONS = [
  { name: 'VK Teams', value: INVITATION_TYPE_VALUES.VK },
  { name: 'E-mail', value: INVITATION_TYPE_VALUES.EMAIL },
  { name: 'СМС', value: INVITATION_TYPE_VALUES.SMS },
];

export type OrganizerChannelOption = {
  name: string;
  value: OrganizerChannel;
};

export const ORGANIZER_CHANNEL_OPTIONS: OrganizerChannelOption[] = [
  { name: 'СМС', value: OrganizerChannel.Sms },
  { name: 'VK Teams', value: OrganizerChannel.Vk },
];

export const mapTicketChannelsToSendChannels = (channels: SelectValue[]): SendChannel[] => {
  const sendChannels: SendChannel[] = [];
  if (channels.includes(INVITATION_TYPE_VALUES.VK)) sendChannels.push(SendChannel.VK);
  if (channels.includes(INVITATION_TYPE_VALUES.EMAIL)) sendChannels.push(SendChannel.Email);
  if (channels.includes(INVITATION_TYPE_VALUES.SMS)) sendChannels.push(SendChannel.SMS);
  return sendChannels;
};
